export default __webpack_public_path__ + "static/media/NoImage.32c61283.jpg";